import { FC, Suspense, useMemo } from 'react';
import { useIsTerminalMode } from 'hooks/useIsTerminalMode';
import { EScreenType, UserPanelSkeleton } from './Skeleton';
import { lazy } from 'utils/generic/lazy';
import { IS_KIOSK_AM_MODE, IS_KIOSK_VENICE_MODE } from 'constants/app/configs';

const { UserPanelWebView } = lazy(
  () => import(/* webpackChunkName: "UserPanelWebView" */ './views/Web')
);

const { UserPanelTerminalView } = lazy(
  () =>
    import(/* webpackChunkName: "UserPanelTerminalView" */ './views/Terminal')
);

const VIEWS = {
  [EScreenType.WEB]: UserPanelWebView,
  [EScreenType.TERMINAL]: UserPanelTerminalView
};

export const UserPanel: FC = () => {
  const { isTerminalMode } = useIsTerminalMode();
  const screenType =
    isTerminalMode || IS_KIOSK_AM_MODE || IS_KIOSK_VENICE_MODE
      ? EScreenType.TERMINAL
      : EScreenType.WEB;
  const View = useMemo(() => VIEWS[screenType], [screenType]);

  return <Suspense fallback={<UserPanelSkeleton />}>{<View />}</Suspense>;
};
